//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as Actions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash';

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------


//  -- List chapter interactions ------


export const handleListHowToVideos = () => async (dispatch) => {
    try {
        const exams = await apis.get('howToVideos', `/list`);
        if (Array.isArray(exams)) {
            const sortedExams = exams.sort((a, b) => a.order_num - b.order_num);
            await dispatch(Actions.listHowToVideosSuccess(sortedExams));
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing how to videos',
                error,
                module: 'HOW_TO_VIDEOS',
                operation: 'LIST_HOW_TO_VIDEO'
            });
        }
    }
};

export const handleCreateHowToVideos = (data) => async (dispatch) => {
    try {
        const videos = await apis.post('howToVideos', `/create`, {
            body: data
        });
        if (has(videos, "id")) {
            await dispatch(Actions.createHowToVideosSuccess(videos));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating how to videos',
                error,
                module: 'HOW_TO_VIDEOS',
                operation: 'CREATE_HOW_TO_VIDEO'
            });
        }
    }
};
export const handleUpdateHowToVideos = (data) => async (dispatch) => {
    try {
        const videos = await apis.put('howToVideos', `/update`, {
            body: data
        });
        if (has(videos, "id")) {
            await dispatch(Actions.updateHowToVideosSuccess(videos));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating how to videos',
                error,
                module: 'HOW_TO_VIDEOS',
                operation: 'UPDATE_HOW_TO_VIDEO'
            });
        }
        console.log(error,"error")
    }
};

export const handleBatchUpdateHowToVideosOrder = (data) => async (dispatch) => {
  try {
    const videos = await apis.put('howToVideos', `/update_by_order`, {
      body: data,
    });
    if (Array.isArray(videos)) {
      await dispatch(Actions.listHowToVideosSuccess(videos));
    }
    return videos;
  } catch (error) {
    if (error && error.message != 'Network Error') {
      logToSentry({
                message: 'updating how to videos',
                error,
                module: 'HOW_TO_VIDEOS',
                operation: 'UPDATE_HOW_TO_VIDEO'
            });
    }
    console.log(error, 'error');
  }
};

export const handleDeleteHowToVideos = (id) => async (dispatch) => {
    try {
        const videos = await apis.del('howToVideos', `/delete/${id}`);
        if (has(videos, "id")) {
            await dispatch(Actions.deleteHowToVideosSuccess(id));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting how to videos',
                error,
                module: 'HOW_TO_VIDEOS',
                operation: 'DELETE_HOW_TO_VIDEO'
            });
        }
    }
};